<template>
    <div class="graphs-content row">
        <div class="col-md-2" id="sideMenu">
            <side-menu :items="menuItems" v-model="selected" />
        </div>
        <div class="col-md-10">
            <div v-if="selected == 0">
                <h2>General relationships</h2>
                <graph
                    :id="selected"
                    :url="generalUrl"
                    type-of-graph="general"
                    direction="UD"
                    level-separation="100"
                    sort-method="hubsize"
                    show-type
                />
            </div>
            <div v-if="selected == 1">
                <h2>Superseding relationships</h2>
                <graph
                    :id="selected"
                    :url="supersedesUrl"
                    type-of-graph="supersedes"
                    direction="LR"
                    level-separation="400"
                    sort-method="directed"
                    hierarchical
                />
            </div>
            <div v-if="selected == 2">
                <h2>Links relationships</h2>
                <graph
                    :id="selected"
                    :url="linksUrl"
                    direction="UD"
                    level-separation="100"
                    sort-method="directed"
                    hierarchical
                />
            </div>
        </div>
        <div id="modal-fullscreen">
            <div id="data-lineage-modal-dialog">
                <div id="data-lineage-modal-content">
                <div id="data-lineage-modal-body">
                    <div class="col-md-10" id="dataLineageGraph" v-if="selected == 3">
                        <h2>Data Lineage</h2>
                        <data-lineage
                            :url="dataLineageUrl"
                            :generate-url="dataLineageGenerateUrl"
                            :source-url="dataLineageSourceUrl"
                            :id="selected"
                            @resize="resizeLineage"
                        />
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import sideMenu from '@/SideMenu.vue'
import graphicalRepresentation from '@/graphs/GraphicalRepresentation.vue'
import GraphicalDataLineage from '@/graphs/GraphicalDataLineage.vue'

export default {
    components: {
        'side-menu': sideMenu,
        'graph': graphicalRepresentation,
        'data-lineage': GraphicalDataLineage
    },
    props: {
        supersedesUrl: {
            type: String,
            required: true
        },
        generalUrl: {
            type: String,
            required: true
        },
        linksUrl: {
            type: String,
            required: true
        },
        dataLineageUrl: {
            type: String,
            default: ''
        },
        dataLineageSourceUrl: {
            type: String,
            default: ''
        },
        dataLineageGenerateUrl: {
            type: String,
            default: ''
        },
        linksActive: {
            type: Boolean,
            default: false
        },
        dataLineageActive: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        selected: 0
    }),
    computed: {
        menuItems: function() {
            let items = ['General', 'Supersedes']
            if (this.linksActive) {
                items.push('Links')
            }
            if (this.dataLineageActive) {
                items.push('Data Lineage')
            }
            return items
        }
    },
    created() {
        // links directly to lineage section: /graphs/#lineage
        if (window.location.hash) {
            if (window.location.hash.substring(1) == 'lineage') {
                this.selected = 3
            }
        }
    },
    methods: {
        // Resize lineage graph, expand it in the full screen
        resizeLineage: function(event) {
            let lineageGraph = document.getElementById('dataLineageGraph')
            let sideMenu = document.getElementById('sideMenu')
            if (event == 'expand') {
                document.getElementById('modal-fullscreen').classList.add('modal', 'fade', 'modal-fullscreen')
                document.getElementById('data-lineage-modal-dialog').classList.add('modal-dialog')
                document.getElementById('data-lineage-modal-content').classList.add('modal-content')
                document.getElementById('data-lineage-modal-body').classList.add('modal-body')
                sideMenu.style.display = 'none'
                lineageGraph.classList.remove('col-md-10')
                lineageGraph.style.height = '100%'
                lineageGraph.style.weight = '100%'
                $('#modal-fullscreen').modal('show')
            } else {
                document.getElementById('modal-fullscreen').classList.remove('modal')
                document.getElementById('data-lineage-modal-dialog').classList.remove('modal-dialog')
                document.getElementById('data-lineage-modal-content').classList.remove('modal-content')
                document.getElementById('data-lineage-modal-body').classList.remove('modal-body')
                $('.modal-backdrop').remove()
                lineageGraph.classList.add('col-md-10')
                sideMenu.style.display = 'block'
            }
        }
    }
}
</script>

<style>
.graphs-content {
    margin-top: 15px
}
#data-lineage-modal-dialog {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}
#data-lineage-modal-content {
    height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
}

.htmlCard {
    width: 250px;
    font-size: 11px;
    font-family: 'Helvetica'
}
.pathTable {
    width: 100%;
    table-layout:fixed
}
.pathColumn {
    padding-left: 5px;
    padding-right: 5px;

    display: block;
    width: 250px;
}
.pathSubColumn {
    white-space: nowrap;
    overflow:hidden;
}

.pathSubTable {
    width: 240px;
    margin-bottom: 0px;
    margin-left: 5px;
    margin-right: 5px;
}
.pathSubTable > tbody > tr > th {
    padding: 0px !important;
    border-right: 1px solid #ddd !important;
    border-top: 0px;
    white-space: nowrap;
    overflow: hidden;
}
.pathSubTable > tbody > tr > th:last-child {
    border-right: 0px !important;
}
.pathSubTable > tbody > tr > td {
    padding: 0px !important;
    border-right: 1px solid #ddd !important;
    max-width: 82px;
    white-space: nowrap;
    overflow: hidden;
}
.pathSubTable > tbody > tr > td:last-child {
    border-right: 0px !important;
}
.pathSubTable > tbody > tr {
    height: 15px;
}
.pathSubTable > tbody > tr:not(:first-child):hover {
    background-color: #ddd;
}

.disLabel {
    color: #3c763d;
    background-color: #dff0d8;
    border: 1px solid green
}
.disCollapse {
    cursor: pointer;
}
.helpIcon {
    cursor: pointer;
    padding-top: 3px;
}

.datasetLabel {
    width: 275px;
    background-color: #337ab7;
    color: white;
    font-size: 11px;
    font-family: 'Helvetica';
    padding-left: 5px;
    padding-right: 5px;
}
</style>
